import QueryString from "qs";

export default (name, options = {}) => {
	const { search = "" } = window.location;
	let params = QueryString.parse(search.substr(1));

	if (options.caseSensitive === false) {
		name = name.toUpperCase();
		params = getUpperCasedAttr(params, options?.firstParamOnly);
	}

	if (options.firstParamOnly && Array.isArray(params[name])) {
		return params[name][0];
	}

	return params[name] ? params[name] : "";
};

const getUpperCasedAttr = (params, firstParamOnly = false) => {
	let updatedObj;

	if (firstParamOnly) {
		let savedKeys = [];
		updatedObj = Object.keys(params).reduce((acc, key) => {
			let found = savedKeys.find(
				(element) => element.toUpperCase() == key.toUpperCase(),
			);
			savedKeys.push(key);
			if (!found) acc[key.toUpperCase()] = params[key];
			return acc;
		}, {});
	} else {
		updatedObj = Object.keys(params).reduce((acc, key) => {
			acc[key.toUpperCase()] = params[key];
			return acc;
		}, {});
	}

	return updatedObj;
};
